import { render, staticRenderFns } from "./faultDetialsPage.vue?vue&type=template&id=5b5345b3&scoped=true"
import script from "./faultDetialsPage.vue?vue&type=script&lang=js"
export * from "./faultDetialsPage.vue?vue&type=script&lang=js"
import style0 from "./faultDetialsPage.vue?vue&type=style&index=0&id=5b5345b3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5345b3",
  null
  
)

export default component.exports